import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Test de debit Internet en ligne";
const DESCRIPTION =
  "Test de debit Internet en ligne. Outil en ligne en francais pour obtenir un resultat rapide, clair et utile dans vos besoins du quotidien.";
const KEYWORDS =
  "internet speed, calculatrice en ligne, outil pratique, utilitaire quotidien, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/internet-speed/";

function InternetSpeedCalculator() {
  const [speed, setSpeed] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const measureSpeed = async () => {
    setIsLoading(true);
    setSpeed(null);
    try {
      const fileSizeInBytes = 5000000;
      const start = new Date().getTime();
      const response = await fetch("https://eu.httpbin.org/stream-bytes/5000000", {
        method: "GET",
        headers: { "Cache-Control": "no-cache" },
      });
      if (response.ok) {
        const end = new Date().getTime();
        const duration = (end - start) / 1000;
        const bitsLoaded = fileSizeInBytes * 8;
        const speedBps = (bitsLoaded / duration).toFixed(2);
        const speedKbps = (speedBps / 1024).toFixed(2);
        const speedMbps = (speedKbps / 1024).toFixed(2);
        setSpeed(`${speedMbps} Mbps`);
      } else {
        alert("Veuillez ressayer ultrieurement.");
      }
    } catch (err) {
      alert("Erreur de connexion. Veuillez ressayer.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "14px" }}>Outil de mesure de vitesse Internet</h2>
                <p>
                  Cet outil mesure la vitesse relle de votre connexion Internet. Il calcule le dbit
                  de tlchargement en tlchargeant un fichier test, puis affiche le rsultat en Mbps
                  (mgabits par seconde).
                </p>
                <h3 style={{ fontSize: "14px" }}>Comment utiliser l'outil</h3>
                <p>
                  Cliquez sur le bouton  Mesurer la vitesse  et attendez que le test se termine.
                  Le rsultat s'affiche en Mbps. Pour obtenir un rsultat prcis, vitez de tlcharger
                  ou d'envoyer des fichiers volumineux pendant le test.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="form-group align-items-center" style={{ justifyContent: "center" }}>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "17px", padding: "10px 30px" }}
                    onClick={measureSpeed}
                    disabled={isLoading}
                  >
                    {isLoading ? "Mesure en cours..." : "Mesurer la vitesse Internet"}
                  </button>
                  <div><br /></div>
                  {speed && (
                    <>
                      <div>
                        <span>Votre vitesse Internet : </span>
                        <b className="alert alert-success">{speed}</b>
                      </div>
                      <br />
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>

      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>Informations sur la mesure de vitesse Internet</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "16px" }}>Facteurs influenant la vitesse Internet</h3>
                <p>
                  La vitesse Internet dpend de plusieurs facteurs : le type de connexion (ADSL, fibre optique,
                  4G/5G), les quipements utiliss (routeur, cbles), et le nombre d'appareils connects
                  simultanment. Il est utile d'effectuer plusieurs mesures  diffrents moments de la journe
                  pour obtenir une image prcise de votre connexion.
                </p>
                <h3 style={{ fontSize: "16px" }}>Comment l'outil mesure la vitesse</h3>
                <p>
                  L'outil tlcharge un fichier test depuis un serveur externe et mesure le temps ncessaire.
                  Il calcule ensuite la vitesse en bits par seconde, convertie en Mbps. Assurez-vous de ne pas
                  effectuer d'autres tlchargements pendant le test.
                </p>
                <h3 style={{ fontSize: "16px" }}>Conseils pour de meilleurs rsultats</h3>
                <ul>
                  <li>Effectuez le test  diffrents moments de la journe pour obtenir une moyenne fiable.</li>
                  <li>Assurez-vous qu'aucun autre appareil n'utilise intensment la connexion pendant le test.</li>
                  <li>Connectez-vous en Wi-Fi ou en cble Ethernet directement depuis votre box.</li>
                  <li>Redmarrez votre routeur si la vitesse mesure est anormalement basse.</li>
                </ul>
                <h3 style={{ fontSize: "16px" }}>Que signifient les units ?</h3>
                <ul>
                  <li><strong>Mbps (mgabits par seconde) :</strong> unit standard de mesure du dbit Internet.</li>
                  <li><strong>1 Mbps</strong> = 1 000 Kbps = tlchargement d'environ 125 Ko/s.</li>
                  <li><strong>10 Mbps</strong> = streaming vido HD sans problme.</li>
                  <li><strong>100 Mbps+</strong> = connexion fibre haut dbit, idale pour 4K et jeux en ligne.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InternetSpeedCalculator;
